import React from "react";
import "../quizzes/QuizzCard.css";
import "../quizzes/TestSeriesCard.css";

import shareIcon from "../../assets/images/sharee.png";
import avatar1 from "../../assets/images/bg3.png";
import avatar2 from "../../assets/images/bg2.png";
import avatar3 from "../../assets/images/bg1.png";
import SafeHtml from '../../components/SafeHtml';

const TestSeriesCard = ({ items = [], onOpen, onShare }) => {
  const testSeriesData = items.map((item, index) => ({
    ...item,
    number: String(index + 1).padStart(2, '0'),
    title: item.name || item.series_name || '',
    description: item.description || '',
    language: item.available_languages || '',
    date: [item.start_date, item.end_date].filter(Boolean).join(' To '),
    free: Number(item.total_free_quiz || item.free_quiz || 0),
    tests: Number(item.total_quiz || item.total_tests || 0),
    attempts: Number(item.total_attempts || 0),
    attemptsLeft: Number(item.attempts_left || item.remaining_attempts || 0),
    progress: Number(item.progress || 0),
  }));
  return (
    <div className="test-series-wrapper">
      {testSeriesData.map((test) => (
        <div className="test-series-card" key={test.number}>

          {/* ================= TOP ================= */}
          <div className="test-series-top">

            {/* Number */}
            <div className="test-series-number">
              {test.number}
            </div>

            {/* Title */}
            <div className="test-series-title-wrap">
              <h3><button type="button" className="search-card-link" onClick={() => onOpen?.(test)}><SafeHtml as="span" inline value={test.title} /></button></h3>
            </div>

            {/* Share */}
            <button type="button" className="test-series-share" onClick={() => onShare?.(test)} aria-label="Share test series">
              <img src={shareIcon} alt="share" />
            </button>

          </div>


          {/* ================= DESCRIPTION ================= */}
          <SafeHtml className="test-series-description" value={test.description} />


          {/* ================= LANGUAGE ================= */}
          <div className="test-series-language">
            <i className="bi bi-translate"></i>
            <SafeHtml as="span" inline value={test.language} />
          </div>


          {/* ================= DATE + AVATARS ================= */}
          <div className="test-series-date-row">

            <div className="test-series-date">
              <i className="bi bi-calendar3"></i>
              <span>{test.date}</span>
            </div>


            {/* Users */}
        <div className="test-series-users">
  <span className="test-series-count">
    {Number(test.total_enrollments || 0)}
  </span>

  <div className="test-series-avatars">
    <img
      src={avatar1}
      alt="User"
      className="test-avatar"
    />

    <img
      src={avatar2}
      alt="User"
      className="test-avatar"
    />

    <img
      src={avatar3}
      alt="User"
      className="test-avatar"
    />
  </div>
</div>

          </div>


          {/* ================= PROGRESS ================= */}
          <div className="test-series-progress">

            <div className="test-series-progress-line">
              <div
                className="test-series-progress-value"
                style={{
                  width: `${Math.min(
                    Math.max(test.progress, 0),
                    100
                  )}%`,
                }}
              ></div>
            </div>

          </div>


          {/* ================= STATS ================= */}
          <div className="test-series-stats">

            {/* FREE */}
            <div className="test-series-stat">

              <div className="test-series-stat-icon">
                <i className="bi bi-gift"></i>
              </div>

              <div>
                <strong className="green-text">
                  {test.free}
                </strong>
                <span className="smallText">Free</span>
              </div>

            </div>


            {/* TESTS */}
            <div className="test-series-stat">

              <div className="test-series-stat-icon">
                <i className="bi bi-calendar3"></i>
              </div>

              <div>
                <strong className="green-text">
                  {test.tests}
                </strong>
                 <span className="smallText">Tests</span>
              </div>

            </div>


            {/* ATTEMPTS */}
            <div className="test-series-stat">

              <div className="test-series-stat-icon">
                <i className="bi bi-check-circle"></i>
              </div>

              <div>
                <strong className="blue-text">
                  {test.attempts}
                </strong>
                   <span className="smallText">Attempts</span>
              </div>

            </div>


            {/* ATTEMPTS LEFT */}
            <div className="test-series-stat">

              <div className="test-series-stat-icon">
                <i className="bi bi-arrow-counterclockwise"></i>
              </div>

              <div>
                <strong className="orange-text">
                  {test.attemptsLeft}
                </strong>
                  <span className="smallText">Attempts Left</span>
              </div>

            </div>

          </div>

        </div>
      ))}
    </div>
  );
};

export default TestSeriesCard;
